/* Rétention — fenêtre d'inscription e-mail (Claude, 2026-10-21).
   Fichier séparé de lp.js : une seule responsabilité, aucun gestionnaire partagé.
   Règles : une seule ouverture par visiteuse (localStorage), jamais pendant que
   le focus est dans le bloc d'achat, après 25 s ou sur intention de sortie (souris). */
(function () {
  var CLE = 'kelvin-inscription-vu';
  var dlg = document.querySelector('[data-lp-inscription]');

  function lire() { try { return localStorage.getItem(CLE); } catch (e) { return '1'; } }
  function marquer() { try { localStorage.setItem(CLE, '1'); } catch (e) {} }

  // Retour après envoi du formulaire : on montre la confirmation (le code) en bas de page.
  if (/[?&]customer_posted=true/.test(location.search)) {
    marquer();
    var bas = document.getElementById('inscription');
    if (bas) bas.scrollIntoView({ block: 'center' });
    return;
  }
  if (!dlg || !dlg.showModal || lire()) return;

  function occupee() {
    var a = document.activeElement;
    return a && a.closest && (a.closest('[data-lp-achat]') || a.matches('input,select,textarea'));
  }
  function ouvrir() {
    if (dlg.open || lire() || occupee()) return;
    marquer();
    dlg.showModal();
    requestAnimationFrame(function () { dlg.classList.add('is-open'); });
  }
  function fermer() {
    if (!dlg.open) return;
    dlg.classList.remove('is-open');
    dlg.classList.add('is-closing');
    setTimeout(function () { dlg.classList.remove('is-closing'); dlg.close(); }, 160);
  }

  dlg.querySelectorAll('[data-lp-inscription-fermer]').forEach(function (b) { b.addEventListener('click', fermer); });
  dlg.addEventListener('click', function (ev) { if (ev.target === dlg) fermer(); });
  dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); fermer(); });

  var minuteur = setTimeout(function essayer() {
    if (occupee()) { minuteur = setTimeout(essayer, 8000); return; }
    ouvrir();
  }, 25000);
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function (ev) {
      if (!ev.relatedTarget && ev.clientY <= 0) { clearTimeout(minuteur); ouvrir(); }
    });
  }
})();
